import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface ColumnProps {
  column: Record<string, { name: string; values: any[] }>;
  showHeader?: boolean;
}

const Column = ({ column, showHeader = true }: ColumnProps) => {
  const columns = Object.values(column);
  const numRows = columns[0]?.values.length || 0;

  return (
    <View style={styles.container} wrap={false}>
      {/* Header Row */}
      {showHeader && (
        <View style={styles.row}>
          {columns.map((col, idx) => (
            <Text key={idx} style={styles.header}>
              {col.name}
            </Text>
          ))}
        </View>
      )}
      {/* Data Rows */}
      {Array.from({ length: numRows }).map((_, rowIdx) => (
        <View key={rowIdx} style={styles.row}>
          {columns.map((col, colIdx) => (
            <Text key={colIdx} style={colIdx === 0 ? styles.cellFirst : styles.cell}>
              {col.values[rowIdx]}
            </Text>
          ))}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    fontSize: 9,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    minHeight: 25,
    fontWeight: 350,
    borderLeft: '1px solid #E8E8E8',
    borderRight: '1px solid #E8E8E8',
  },
  cell: {
    flex: 1,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 4,
    paddingRight: 4,
    textAlign: 'left',
    marginLeft: 0,
    marginRight: 0,
  },
  cellFirst: {
    flex: 1,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 4,
    paddingRight: 4,
    textAlign: 'left',
    marginLeft: 0,
    marginRight: 0,
  },
  header: {
    flex: 1,
    color: '#FFFFFF',
    backgroundColor: '#40ADE2',
    fontWeight: 'bold',
    padding: 4,
    minHeight: 20,
    textAlign: 'left',
  },
});

export default Column;
